export const constants = {
    notOffered: '(N.O.)',
    subject: '(Subj.)'
}
